// Call-to-action strip that points price-board visitors at the member card
// collection binder. Rendered directly above the price chart and on the price
// dashboard so the "track what you own" option is discoverable.
import { Link } from "@tanstack/react-router";
import { ArrowRight, LineChart, Wallet } from "lucide-react";

export function CollectionCta({ className = "" }: { className?: string }) {
  return (
    <section
      aria-label="Track your Palworld card collection"
      className={`glass relative overflow-hidden rounded-2xl border border-primary/30 p-5 ${className}`}
    >
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 bg-gradient-to-r from-primary/15 via-transparent to-transparent"
      />
      <div className="relative flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-3">
          <span className="mt-0.5 rounded-xl bg-primary/15 p-2 text-primary">
            <Wallet className="h-5 w-5" aria-hidden="true" />
          </span>
          <div>
            <p className="text-sm font-bold sm:text-base">Track the Palworld cards you own — free</p>
            <p className="aeo-answer mt-1 max-w-2xl text-sm text-muted-foreground">
              Log every card in your collection binder with the price you paid and the price you sold it for. Pal Stars
              prices it against today's live marketplace data and shows banked profit, paper profit and ROI per card —
              and you can share the whole binder with one public link.
            </p>
          </div>
        </div>
        <div className="flex shrink-0 flex-wrap gap-2">
          <Link
            to="/collection"
            className="inline-flex items-center gap-1.5 rounded-xl bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground hover:opacity-90"
          >
            Open my collection binder
            <ArrowRight className="h-4 w-4" aria-hidden="true" />
          </Link>
          <Link
            to="/price-dashboard"
            className="inline-flex items-center gap-1.5 rounded-xl border border-border/60 px-4 py-2 text-sm font-semibold hover:border-primary/60"
          >
            <LineChart className="h-4 w-4" aria-hidden="true" />
            Market dashboard
          </Link>
        </div>
      </div>
    </section>
  );
}
